export default {
    'zh-CN': {
        home: '首页',
        switchLangTitle: '切换语言',
        international: '多语言切换',
        userCenter: '个人中心',
        changePass: '修改密码',
        logout: '退出登录',
        tagOption: '标签选项',
        closeAll: '关闭全部',
        closeOthers: '关闭其他',
        tip: '注：iview-admin只是为了示范如何实现多语言切换，所以只对当前页做了翻译。',
    },
    'en-US': {
        home: 'home',
        switchLangTitle: 'Switch Lang',
        international: 'Switch Lang',
        userCenter: 'User Center',
        changePass: 'Change Pass',
        logout: 'Logout',
        tagOption: 'Tag Options',
        closeAll: 'Close All',
        closeOthers: 'Close Others',
        tip: 'Note: iview-admin just to demonstrate how to achieve multi-language switching, so only the current page to do the translation.',
    }
};
